export default __webpack_public_path__ + "bart_april_1st.63d1e383.png";